import request from '@/common/request'

class EmpresaService {
  getAll() {
    return request.get('/empresas')
  }

  create(data) {
    return request.post('/empresas', data)
  }

  update(id, data) {
    return request.patch(`/empresas/${id}`, data)
  }

  deleteById(id) {
    return request.delete(`/empresas/${id}`)
  }
}

export default new EmpresaService()
